import { ListItemText, MenuItem } from '@mui/material';
import { useMemo } from 'react';
import { CustomMenu } from '../../../private/components/CustomMenu';
import type { RendererHookProps } from '../../../private/plugins/AfterPastePlugin';
import type { AfterPasteContext } from './shared/types';
import { embedSuggestionState } from './state';

export const EmbedSuggestionMenu = ({
  clientRect,
  editor,
  onClose,
  data: { link },
  range,
}: RendererHookProps<AfterPasteContext>) => {
  const items = useMemo(() => {
    const { findMatches } = embedSuggestionState.getState();
    return findMatches(link);
  }, [link]);

  const selectItem = (type: string) => {
    const item = items.find((item) => item.type === type);
    if (!item) return;
    item.command({ editor, range, link });
    onClose();
  };

  return (
    <CustomMenu
      clientRect={clientRect}
      editor={editor}
      totalItems={1 + items.length}
      onClose={onClose}
      selectItem={(index) => {
        if (index === 0) {
          onClose();
          return;
        }

        selectItem(items[index - 1].type);
      }}
    >
      {({ selectedIndex }) => [
        <MenuItem
          selected={selectedIndex === 0}
          onClick={onClose}
          key="do-nothing"
        >
          <ListItemText primary="Do Nothing" />
        </MenuItem>,

        ...items.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => selectItem(item.type)}
            selected={selectedIndex === index + 1}
          >
            <ListItemText primary={item.name} />
          </MenuItem>
        )),
      ]}
    </CustomMenu>
  );
};
